const LAYER_TYPE = {
  TRACT: 'tract',
  COUNTY: 'county',
  STATE: 'state',
};

const MAX_ZOOM_LEVEL = {
  [LAYER_TYPE.TRACT]: 8,
  [LAYER_TYPE.COUNTY]: 6,
};

let isLayerVisible = function (layerType, zoomLevel = 20) {
  if (layerType === LAYER_TYPE.TRACT) {
    return zoomLevel >= MAX_ZOOM_LEVEL[LAYER_TYPE.TRACT];
  }

  if (layerType === LAYER_TYPE.COUNTY) {
    return (
      zoomLevel < MAX_ZOOM_LEVEL[LAYER_TYPE.TRACT] &&
      zoomLevel >= MAX_ZOOM_LEVEL[LAYER_TYPE.COUNTY]
    );
  }

  // Else layerType === LAYER_TYPE.STATE.
  return zoomLevel < MAX_ZOOM_LEVEL[LAYER_TYPE.COUNTY];
};

export { LAYER_TYPE, MAX_ZOOM_LEVEL, isLayerVisible };
